<template>
  <BaseCalculator
    :expanded="expanded"
    :subgroupingId="subgroupingId"
    :title="title"
    :tooltip="tooltip"
    >
    <template v-slot:basecalculator-row-1-col-2="scopeProps">
      <GenericInput
        v-if="scopeProps.fields[1]"
        :id="`calculator-${subgroupingId}-field-${scopeProps.fields[1].id}`"
        v-model="scopeProps.fields[1].value"
        :disabled="scopeProps.isReadOnly ?? false"
        :doubleLineHeight="true"
        :fieldId="scopeProps.fields[1].id"
        :lable="scopeProps.fields[1].lable"
        :max="scopeProps.fields[1].maximumValue"
        :min="scopeProps.fields[1].minimumValue"
        :possibleValues="scopeProps.fields[1].possibleValues"
        :regex="findRegexPattern(scopeProps.fields[1].validationRegex)"
        :required="scopeProps.fields[1].required"
        :step="scopeProps.fields[1].step"
        :tooltip="scopeProps.fields[1].tooltip"
        :type="scopeProps.fields[1].valueType"
        :validationError="scopeProps.fields[1].error"
        @selectedDependents="(arg1, arg2) => scopeProps.setSelectedDependent(arg1, arg2)"
        @update:modelValue="scopeProps.applyConditions"
        @value-invalid="(arg1, arg2) => scopeProps.applyValidationError(arg1, arg2)"
        @value-valid="(arg1) => scopeProps.applyValidationOk(arg1)"
        @input="scopeProps.setCalculationChanged"
        @focusout="scopeProps.setCalculationChanged"
      />
    </template>
    <template v-slot:basecalculator-row-1-col-3="scopeProps">
      <GenericInput
        v-if="scopeProps.fields[2]"
        :id="`calculator-${subgroupingId}-field-${scopeProps.fields[2].id}`"
        v-model="scopeProps.fields[2].value"
        :disabled="scopeProps.isReadOnly ?? false"
        :doubleLineHeight="true"
        :fieldId="scopeProps.fields[2].id"
        :lable="scopeProps.fields[2].lable"
        :max="scopeProps.fields[2].maximumValue"
        :min="scopeProps.fields[2].minimumValue"
        :possibleValues="filter(scopeProps.fields[2].possibleValues?.filter((e) => scopeProps.fields[1].selectedDependents?.map((dependent) => dependent.id).includes(e.id)), subgroupingId)"
        :regex="findRegexPattern(scopeProps.fields[2].validationRegex)"
        :required="scopeProps.fields[2].required"
        :step="scopeProps.fields[2].step"
        :tooltip="scopeProps.fields[2].tooltip"
        :type="scopeProps.fields[2].valueType"
        :validationError="scopeProps.fields[2].error"
        @selectedDependents="(arg1, arg2) => scopeProps.setSelectedDependent(arg1, arg2)"
      />
    </template>
    <template v-slot:basecalculator-row-1-col-4="scopeProps">

      <GenericInput
        v-if="scopeProps.fields[3]"
        :id="`calculator-${subgroupingId}-field-${scopeProps.fields[3].id}`"
        v-model="scopeProps.fields[3].value"
        :disabled="scopeProps.isReadOnly ?? false"
        :doubleLineHeight="true"
        :fieldId="scopeProps.fields[3].id"
        :lable="scopeProps.fields[3].lable"
        :max="scopeProps.fields[3].maximumValue"
        :min="scopeProps.fields[3].minimumValue"
        :possibleValues="scopeProps.fields[3].possibleValues"
        :regex="findRegexPattern(scopeProps.fields[3].validationRegex)"
        :required="scopeProps.fields[3].required"
        :step="scopeProps.fields[3].step"
        :tooltip="scopeProps.fields[3].tooltip"
        :type="scopeProps.fields[3].valueType"
        :validationError="scopeProps.fields[3].error"
        @update:modelValue="scopeProps.applyConditions"
        @value-invalid="(arg1, arg2) => scopeProps.applyValidationError(arg1, arg2)"
        @value-valid="(arg1) => scopeProps.applyValidationOk(arg1)"
        @input="scopeProps.setCalculationChanged"
        @focusout="scopeProps.setCalculationChanged"
      />
    </template>
    <template v-slot:basecalculator-row-1-col-5="scopeProps">
      <GenericInput
        v-if="scopeProps.fields[4] &&
              scopeProps.fields[4].id &&
              scopeProps.fields[4].id !== constants.INPUT_ENHED_FYSISKE &&
              scopeProps.fields[4].valueType !== 'DROPDOWN_DEPENDENT'
                  "
        :id="`calculator-${subgroupingId}-field-${scopeProps.fields[4].id}`"
        v-model="scopeProps.fields[4].value"
        :disabled="scopeProps.isReadOnly ?? false"
        :doubleLineHeight="true"
        :fieldId="scopeProps.fields[4].id"
        :lable="scopeProps.fields[4].lable"
        :max="scopeProps.fields[4].maximumValue"
        :min="scopeProps.fields[4].minimumValue"
        :possibleValues="scopeProps.fields[4].possibleValues"
        :regex="findRegexPattern(scopeProps.fields[4].validationRegex)"
        :required="scopeProps.fields[4].required"
        :step="scopeProps.fields[4].step"
        :tooltip="scopeProps.fields[4].tooltip"
        :type="scopeProps.fields[4].valueType"
        :validationError="scopeProps.fields[4].error"
        @update:modelValue="scopeProps.applyConditions"
        @value-invalid="(arg1, arg2) => scopeProps.applyValidationError(arg1, arg2)"
        @value-valid="(arg1) => scopeProps.applyValidationOk(arg1)"
        @selectedDependents="(arg1, arg2) => scopeProps.setSelectedDependent(arg1, arg2)"
      />
      <GenericInput
        v-else-if="scopeProps.fields[4]"
        :id="`calculator-${subgroupingId}-field-${scopeProps.fields[4].id}`"
        v-model="scopeProps.fields[4].value"
        :disabled="scopeProps.isReadOnly ?? false"
        :doubleLineHeight="true"
        :fieldId="scopeProps.fields[4].id"
        :lable="scopeProps.fields[4].lable"
        :max="scopeProps.fields[4].maximumValue"
        :min="scopeProps.fields[4].minimumValue"
        :possibleValues="
                    scopeProps.fields[4].possibleValues?.filter((e) => scopeProps.fields[2].selectedDependents?.map((dependent) => dependent.name).includes(e.name))
                  "
        :regex="findRegexPattern(scopeProps.fields[4].validationRegex)"
        :required="scopeProps.fields[4].required"
        :step="scopeProps.fields[4].step"
        :tooltip="scopeProps.fields[4].tooltip"
        :type="scopeProps.fields[4].valueType"
        :validationError="scopeProps.fields[4].error"
        @update:modelValue="scopeProps.applyConditions"
        @value-invalid="(arg1, arg2) => scopeProps.applyValidationError(arg1, arg2)"
        @value-valid="(arg1) => scopeProps.applyValidationOk(arg1)"
        @input="scopeProps.setCalculationChanged"
        @focusout="scopeProps.setCalculationChanged"
      />
    </template>
  </BaseCalculator>
</template>

<script lang="ts">
import BaseCalculatorComponent from "@/components/calculator/base-components/BaseCalculatorComponent"
import {FieldEnum} from "../../../../../openapi/generated-clients/climatecompass";
export default class CommonProductsAndServicesCalculator extends BaseCalculatorComponent {

  filter(items : Array<FieldEnum>, subgroupingId : number | undefined) : Array<FieldEnum>  {
    // quick and dirty fix: for produkter og services remove "Generelt" from dropdown if sg = 13 but leave untuched e.g if sg = 14
    // would be better to directly solve in db, but this requires new field_enum rows for sg=14 and all existing calculations must be
    // changed in a job
    if (items && subgroupingId === 13) {
      return items.filter(value => value.id !== 121)
    }
    if (items && subgroupingId === 23) {
      return items.filter(value => value.id !== 121)
    }
    return items
  }

}
</script>

<style scoped>

</style>